// import config from '@/config'
import popularParlays from './popularParlays'
import recommended from './recommended'
import playerProps from './playerProps'

export default {
  popularParlays,
  recommended,
  playerProps
}



// WEBPACK FOOTER //
// ./src/library/personalization/index.js